// extracted by mini-css-extract-plugin
export default {"displayTitleDiv":"weeklySummaryChart_displayTitleDiv__lxTjR","displayTitle":"weeklySummaryChart_displayTitle__8Q054","rankDiv":"weeklySummaryChart_rankDiv__rex9P"};